import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EventComponent} from './event.component';
import {EventDetailResolver} from "@biletix/features/event/resolvers/event-detail.resolver";
import { CartResetTimeoutResolver } from '@biletix/core/resolvers/cart-reset-timeout.resolver';

const routes: Routes = [
  {
    path: '',
    component: EventComponent,
    resolve: {
      eventDetail: EventDetailResolver,
      cartTimeout: CartResetTimeoutResolver
    }
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EventRoutingModule {
}
